import React from 'react'
import Modal from '../../components/modals/cancelModal'

const CancelLink = ({ index, PassDataItems, apiAuthHeaders, }) => {
    const triggerId = `cancelModalTrigger${index ?? PassDataItems.REQUEST_ID}`

    return (
        <div>
            <li>
                <strong>
                    <p>
                        <button type="button" id={triggerId} className="linkButton" aria-haspopup="dialog"
                                tabIndex="0">Cancel Request
                        </button>
                    </p>
                </strong>
            </li>
            <Modal triggerId={triggerId} apiAuthHeaders={apiAuthHeaders} PassDataItems={PassDataItems} />
        </div>
    )
}

export default CancelLink
